var _style, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 175.92 175.91",
    style: {
      enableBackground: "new 0 0 175.92 175.91"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 51.5327,
    cy: 189.5443,
    r: 233.1221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0969,
    style: {
      stopColor: "#FFD879"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1539,
    style: {
      stopColor: "#FCCB76"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2583,
    style: {
      stopColor: "#F5AA6C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3976,
    style: {
      stopColor: "#E9755E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    style: {
      stopColor: "#E45F58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6786,
    style: {
      stopColor: "#D22A9C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6968DF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.92,139.79c0,19.95-16.18,36.13-36.13,36.13H36.13C16.18,175.92,0,159.74,0,139.79V36.14 C0,16.18,16.18-0.01,36.13-0.01h103.65c19.95,0,36.13,16.19,36.13,36.14V139.79z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.42,21.62H62.5c-22.58,0-40.88,18.3-40.88,40.88v50.92c0,22.57,18.3,40.87,40.88,40.87h50.92 c22.58,0,40.88-18.3,40.88-40.87V62.5C154.3,39.92,136,21.62,113.42,21.62z M141.56,108.53c0,18.25-14.79,33.03-33.03,33.03 H67.39c-18.25,0-33.03-14.78-33.03-33.03V67.38c0-18.24,14.79-33.03,33.03-33.03h41.15c18.24,0,33.03,14.8,33.03,33.03V108.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.74,53.24c-19.31,0-34.95,15.64-34.95,34.94c0,19.29,15.65,34.95,34.95,34.95 c19.3,0,34.95-15.65,34.95-34.95C124.69,68.88,109.04,53.24,89.74,53.24z M89.74,109.21c-11.62,0-21.03-9.42-21.03-21.02 c0-11.62,9.41-21.03,21.03-21.03c11.61,0,21.02,9.41,21.02,21.03C110.76,99.8,101.35,109.21,89.74,109.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.15,52.7c0,4.91-3.99,8.89-8.89,8.89c-4.91,0-8.88-3.98-8.88-8.89c0-4.91,3.98-8.89,8.88-8.89 C127.17,43.81,131.15,47.79,131.15,52.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.9825459f1ad0c7f22f0c915db5f3e5fa.svg";
export { ForwardRef as ReactComponent };